import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
} from "../../components";

import "./styles.css";

const Address = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );
  const studentProfile = useSelector(
    (state) => state?.students?.student?.common
  );

  const [state, setState] = useState({
    addressLane1: "",
    addressLane2: "",
    addressLane3: "",
    postalCode: "",
  });

  useEffect(() => {
    setState({
      addressLane1: questionnaire?.addressLane1 ?? "",
      addressLane2: questionnaire?.addressLane2 ?? "",
      addressLane3: questionnaire?.addressLane3 ?? "",
      postalCode: questionnaire?.postalCode ?? "",
    });
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      <div className="grid grid-cols-2 gap-x-7 gap-y-6">
        <div className="col-span-2">
          <questionnaireComponents.QuestionnaireLabel text="Lane 1" required />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            value={state?.addressLane1}
          />
        </div>
        <div className="col-span-2">
          <questionnaireComponents.QuestionnaireLabel text="Lane 2" />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            value={state?.addressLane2}
          />
        </div>
        <div className="col-span-2">
          <questionnaireComponents.QuestionnaireLabel text="Lane 3" />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            value={state?.addressLane3}
          />
        </div>
        <div>
          <questionnaireComponents.QuestionnaireLabel text="Zip/Postal Code" />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            type="number"
            value={state?.postalCode}
          />
        </div>

        <div>
          <questionnaireComponents.QuestionnaireLabel text="Country" required />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            value={studentProfile?.country}
          />
        </div>

        <div>
          <questionnaireComponents.QuestionnaireLabel text="City" required />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            value={studentProfile?.city}
          />
        </div>
      </div>
      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("Education")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default Address;
